import { useAppSelector, useWindowDimensions } from '@/hook';
import { PriceBreakDownBottomSheet } from './price-breakdown-bottomsheet';
import { PriceBreakDownModal } from './price-breakdown-modal';
import { Dispatch, SetStateAction } from 'react';
import { CarTypesEnum } from '@/components/car-details-v2/car-type';
import { useTranslation } from 'react-i18next';
import { AVAILABLE_LANGUAGES } from '@/constants';
import { gradientColors } from '../../../constants';

export const PriceBreakDownContent = ({
    open,
    setOpen,
    carType,
}: {
    open: boolean;
    setOpen: Dispatch<SetStateAction<boolean>>;
    carType: CarTypesEnum;
}) => {
    const { t, i18n } = useTranslation();
    const { IS_DESKTOP } = useWindowDimensions();
    const { selectedCar } = useAppSelector(state => state.checkout);
    const gradientClass =
        carType === CarTypesEnum.CERTIFIED
            ? 'from-certified-50 via-certified-50/[60%]'
            : carType === CarTypesEnum.LITE
            ? 'from-lite-50 via-lite-50/[60%]'
            : 'from-dealer-50 via-dealer-50/[60%]';
    const gradientColor = gradientColors(carType);
    return (
        <>
            {IS_DESKTOP ? (
                <PriceBreakDownModal
                    openModal={open}
                    setOpenModal={setOpen}
                    gradient={gradientColor}
                    selectedCar={selectedCar}
                    carType={carType}
                    t={t}
                    lang={i18n.language as AVAILABLE_LANGUAGES}
                />
            ) : (
                <PriceBreakDownBottomSheet
                    openBottomSheet={open}
                    setOpenBottomSheet={setOpen}
                    gradient={gradientClass}
                    selectedCar={selectedCar}
                    carType={carType}
                    t={t}
                    lang={i18n.language as AVAILABLE_LANGUAGES}
                />
            )}
        </>
    );
};
